import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
  Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js';
import moment from 'moment'
import {
  BasicSelect
} from 'vue-search-select';
import VueElementLoading from 'vue-element-loading'
import Printd from 'printd'
import download from 'downloadjs';
import index from '../../../utils/index'
import Multiselect from 'vue-multiselect';

export default {
  name: 'vehicle-trip-summary',
  components: {
    Paginate,
    DatePicker,
    BasicSelect,
    VueElementLoading,
    download,
    Multiselect
  },
  props: [],
  data() {
    return {
      pageCountrule: 0,
      pageCount: 0,
      pageCountForBags:0,
      pageNo: 0,
      pageNoForBagList:0,
      bagCount:0,
      shippingDetails: {},
      showModal: false,
      isLoadingSearch: false,
      shippingID: '',
      transactions: [],
      shippingIDErrorMSG: '',
      isEmpty: 0,
      routeType: '',
      hubLoading: '',
      vendorLoading: '',
      hubNameObjData: {
        value: "",
        text: ""
      },
      srcHubName: '',
      HubNameData: [],
      VendorNameData: [],
      vendorNameObjData: {
        value: "",
        text: ""
      },
      vendorName: '',
      vendorData: [],
      DestHubNameData: [],
      status: '',
      IsLocalConnection: '',
      routeName: '',
      routenamelist: [],
      routenameitem: {
        value: "",
        text: "",
        route: ""
      },
      routenameLoading: '',
      CurrentHubNameObjData: {
        value: "",
        text: ""
      },
      currentHubName: '',
      CurrentHubNameData: [],
      allHubMaster: [],
      tripSummaryDetails: [],
      tripSheetNo: '',
      FromDate: '',
      ToDate: '',
      thcno: '',
      PrintDate: '',
      PrintBy: '',
      Signature: '',
      Name: '',
      obj: '',
      viewtripmodel: false,
      showTable: false,
      showConnectionLogTable: false,
      isLoading: false,
      opened: [],
      VehicleTripDetailsData: [],
      ConnectionLogFinalData: [],
      hubdetailsarray: [],
      GatePassDetails: [],
      DestLoadCount: [],
      DestLoadCountUpdated: [],
      ebnDetailsB2B: [],
      ebnDetailsB2C: [],
      actualRoute: '',
      ConnectionScheduleMasterID: '',
      invoiceno: '',
      CSMID: '',
      validDateRange: '',
      pageNo: 0,
      limit: 10,
      pageNoLog: 0,
      limitLog: 10,
      limitBag:10,
      pageCountLog: 0,
      totalRows: 0,
      totalRowsNew: 0,
      totalRowsBags:0,
      hubId: '',
      //for RegularPrint
      showPrintModal: false,
      isLoadingPrintSheet: false,
      modaldata: '',
      tripdatafound: false,
      vendortype: '',
      currenthub: '',
      fullConnectionName: '',
      shipmentdataLength: 0,
      shipmentdata: [],
      isDisplay: true,
      printBy: '',
      printDate: '',
      touchpointlist: [],
      touchpointitem: {
        value: '',
        text: ''
      },
      touchpointname: '',
      showBagListModal:false,
      bags:[],
      shipments:[],
      checkType:'Ecom',
      isLoadingBagList:false,
      csvDataForCargo:[],
      isValidPrint : false,
      printConfig : false,
      hubName : '',
      printTripNo: '',
    }
  },
  computed: {

  },
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    },
    toFixedNum: function(val) {
      if (val && val > 0) {
        return Number(parseFloat(val).toFixed(2));
      } else {
        return 0;
      }
      // var with2Decimals = val.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
      // return  with2Decimals
    },
    //for RegularPrint
    momentDate: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY');
    },
    momentTime: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('HH:mm:ss');
    },
  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext)
    this.warehouseid = userdetail[0].warehouseid;
    this.createdBy = userdetail[0].email;
    this.hubId = userdetail[0].HubId[0];
    this.useremail = userdetail[0].email;
    this.getHubName();
    //this.getRouteName();
    //this.getVendor();
    //for RegularPrint
    this.printDate = moment().format('DD-MM-YYYY');
    this.printBy = userdetail[0].email;
  },
  methods: {
    selectedHub(hubName) {
      this.hubNameObjData = hubName;
      this.srcHubName = this.hubNameObjData.text
      this.hubNameObjData = hubName;
      var a = this.hubNameObjData.value
      // this.DestHubNameData = this.allHubMaster.filter(function(el) {
      //   return el.value != a
      // });
      this.hubName = hubName.text.split(' ')[0];
      this.srcHubName = hubName.value
      this.actualRoute = ''
      this.routenamelist = []
      this.routenameitem = {
        value: "",
        text: "",
        route: ""
      }
      if (this.hubNameObjData.value == undefined) {
        return false;
      }
      if (this.srcHubName != "" && this.routeType != "") {
        this.getRouteName();
        this.getVendor();
      }
    },
    getHubName() {
      this.hubLoading = 'Loading Hub...'
      var i = 0;
      var self = this
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'hubservicecenter/list',
          // 'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.hubLoading = ''
          var HubNameData = result.data.ResponseData
          this.hubdetailsarray = result.data.ResponseData
          for (i = 0; i < HubNameData.length; i++) {
            this.DestHubNameData.push({
              value: HubNameData[i].HubID,
              text: HubNameData[i].HubName + ' (' + HubNameData[i].HubID + ')'
            })
            this.HubNameData = this.DestHubNameData
            this.CurrentHubNameData = this.DestHubNameData
            this.allHubMaster = this.DestHubNameData
          }
        }, error => {
          console.error(error)
        })
      // this.srcHubName!=''?this.getConnectionName():''
    },
    selectedVendor(vName) {
      this.vendorNameObjData = vName;
      this.vendorName = vName.value
    },
    selectRouteName(routenameitem) {
      this.routenameitem = routenameitem
      this.routeName = this.routenameitem.value
      this.actualRoute = routenameitem.route
    },
    selectedCurrentHub(CurrentHubNameObjData) {
      this.CurrentHubNameObjData = CurrentHubNameObjData
      this.currentHubName = CurrentHubNameObjData.text
    },
    checkRouteType() {
      this.routenamelist = []
      this.routenameitem = {
        value: '',
        text: ''
      }
      this.routeName = ''
      this.actualRoute = ''
      this.VendorNameData = []
      this.vendorNameObjData = {
        value: '',
        text: ''
      }
      this.vendorName = ''
      this.$validator.reset();
      // if (this.routeType == 1) {
      //   this.IsLocalConnection = true
      // } else {
      //   this.IsLocalConnection = false
      // }
      // this.getRouteName()
      // this.getVendor()
      if (this.routeType != "" && this.srcHubName != "") {
        this.getRouteName();
        this.getVendor();
      }
    },
    getVendor() {
      this.vendorLoading = 'Loading Vendor...'
      var i = 0;
      var routeType = ""
      if (this.routeType == "4") {
        routeType = "local"
      } else {
        routeType = "network"
      }
      var self = this
      this.input = {
        "IsActive": 1,
        "VendorType": routeType,
        "HubID": this.hubId
      };
      axios({
          'method': 'POST',
          'url': apiUrl.api_url_hubops + 'findVendorForTypeAllocation',
          'data': this.input,
          'headers': {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          this.vendorLoading = '';
          if (result.data.ResultCode == 100) {
            var VendorNameData = result.data.ResponseData
            for (i = 0; i < VendorNameData.length; i++) {
              this.vendorData.push({
                value: VendorNameData[i].vehicleVendorID,
                text: VendorNameData[i].VehicleVendorCompanyName + ' (' + VendorNameData[i].vehicleVendorID + ')'
              })
              this.VendorNameData = this.vendorData
            }
          }
        }, error => {
          this.vendorLoading = '';
          console.error(error)
        })
    },
    getRouteName() {
      this.routenameLoading = 'Loading Route Name...'
      var self = this
      var i = 0;
      this.input = {
        source: parseInt(this.hubNameObjData.value),
        type: parseInt(this.routeType)
      }
      //
      // if (this.hubNameObjData.value) {
      //   this.input.source = Number(this.hubNameObjData.value)
      // }
      // this.input.type = 0;
      axios({
          'method': 'POST',
          'url': apiUrl.api_url_hubops + 'getroutemaster',
          'data': this.input,
          'headers': {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          this.routenameLoading = ''
          if (result.data.ResultCode == 100) {
            var listConnectionNameData = result.data.ResponseData;
            for (i = 0; i < listConnectionNameData.length; i++) {
              this.routenamelist.push({
                value: listConnectionNameData[i].ConnectionID,
                // text: listConnectionNameData[i].ConnectionName + ' (TP- ' + listConnectionNameData[i].Stoppoints.length + ')',
                text: listConnectionNameData[i].FullConnectionName,
                route: listConnectionNameData[i].FullConnectionName
              })
            }
          } else {
            this.$alertify.error("No Connection found")
          }
        }, error => {
          this.routenameLoading = ''
          this.$alertify.error("Connection API Error")
          console.error(error)
        })
    },
    showModalOnClick(shippingDetails) {
      this.transactions = shippingDetails.Transactions
      this.showModal = true
    },
    closeModal() {
      this.showModal = false;
      $(document.body).removeClass("modal-open");
      $(".modal-backdrop").remove();
    },
    getdate(date) {
      var today = new Date(date);
      var dd = today.getDate();
      var mm = today.getMonth() + 1; //January is 0!
      var yyyy = today.getFullYear();
      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }
      var today = yyyy + '-' + mm + '-' + dd;
      return today;
    },
    getVehicleTripSummary() {
      this.opened.splice(0, 1);
      this.totalRows = 0
      this.tripSummaryDetails = []
      var FromDate = this.FromDate != '' ? this.getdate(this.FromDate) : ''
      var ToDate = this.ToDate != '' ? this.getdate(this.ToDate) : ''
      this.IsLocalConnection = false
      this.showTable = true
      var isactive = true
      this.isLoadingSearch = true;
      var ConnectionScheduleMasterID = this.ConnectionScheduleMasterID != '' ? this.ConnectionScheduleMasterID : ''
      this.input = ({})
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'tripConnectionScheduleReport?ConnectionScheduleMasterID=' + ConnectionScheduleMasterID + '&ConnectionID=' + this.routenameitem.value +
            '&VehicleVendorID=' + this.vendorNameObjData.value + '&ScheduleStatus=' + this.status + '&CurrentHubId=' + this.CurrentHubNameObjData.value +
            '&THCNo=' + this.tripSheetNo + '&IsLocalConnection=' + this.IsLocalConnection + '&IsActive=' + isactive + '&FromDate=' + FromDate + '&ToDate=' + ToDate +
            '&RequestType=report&offset=' + this.pageNo + '&limit=' + this.limit,

          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          this.isLoadingSearch = false;
          if (result.data.ResultCode == 100) {
            this.tripSummaryDetails = result.data.ResultData;
            this.totalRows = result.data.TotalCount
            this.$alertify.success(result.data.ReturnMessage)
            if (this.totalRows < 10) {
              this.pageCount = 1
            } else {
              this.pageCount = Math.ceil(this.totalRows / 10);
            }
            this.showTable = true
          } else {
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          console.error(error)
        })
    },
    ExportVehicleTripSummaryForCSVValidate(){
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.ExportVehicleTripSummaryForCSV()
        } else {
          console.log('errors exist', this.errors)
        }
      }).catch(() => {
        console.log('errors exist')
      });

    },  

    ExportVehicleTripSummaryForCSV() {
      this.opened.splice(0, 1);
      this.totalRows = 0
      var TripList = []
      var FromDate = this.FromDate != '' ? this.getdate(this.FromDate) : ''
      var ToDate = this.ToDate != '' ? this.getdate(this.ToDate) : ''
      this.IsLocalConnection = false
      this.showTable = true
      var isactive = true
      this.isLoadingSearch = true;
      var ConnectionScheduleMasterID = this.ConnectionScheduleMasterID != '' ? this.ConnectionScheduleMasterID : ''
      this.input = ({})
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'tripConnectionScheduleReportExportCsv?ConnectionScheduleMasterID=' + ConnectionScheduleMasterID + '&ConnectionID=' + this.routenameitem.value +
            '&VehicleVendorID=' + this.vendorNameObjData.value + '&ScheduleStatus=' + this.status + '&CurrentHubId=' + this.CurrentHubNameObjData.value +
            '&THCNo=' + this.tripSheetNo + '&IsLocalConnection=' + this.IsLocalConnection + '&IsActive=' + isactive + '&FromDate=' + FromDate + '&ToDate=' + ToDate +
            '&RequestType=report',

          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          this.isLoadingSearch = false;
          if (result.data.ResultCode == 100) {
            TripList= result.data.ResultData.map((el)=>{
              return{
                "thcno": el.thcno,
                "connectionname":el.connectionname,
                "vehicleno": el.vehicleno,
                "vendorname": el.vendorname,
                "invoiceno": el.invoiceno,
                "schedulestatus": el.schedulestatus,
                "createddate": el.createddate,
                "lastmodifiedby": el.lastmodifiedby,
                "lastmodifieddate": el.lastmodifieddate
              }
            });
            this.showTable = true
            console.log(this.csvFields);
            this.csvFields = {
              "thcno": "thcno",
              "connectionname":"connectionname",
              "vehicleno": "vehicleno",
              "vendorname": "vendorname",
              "invoiceno": "invoiceno",
              "schedulestatus": "schedulestatus",
              "createddate": "createddate",
              "lastmodifiedby": "lastmodifiedby",
              "lastmodifieddate": "lastmodifieddate"
            }
            this.jsonToCSV('Trip_Status_Report_', TripList, this.csvFields);
          }
          else{
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          console.error(error)
        })
    },
    getPaginationData(pageNum) {
      this.pageNo = (pageNum - 1)
      this.getVehicleTripSummary()
    },
    getPaginationDataLog(pageNum) {
      this.pageNoLog = (pageNum - 1)
      this.getConnectionLogTable()
    },
    getPaginationDataForBagList(pageNum) {
      this.pageNoForBagList = (pageNum - 1)
      this.ShowBagList()
    },
    //for RegularPrint
    gettotalshipments(d) {
      var totalShipments = 0;
      for (var i = 0; i < d.length; i++) {
        totalShipments = totalShipments + parseInt(d[i].shipmentcount)
      }
      return totalShipments;
    },
    gettotalphywt(d) {
      var totalphywt = 0;
      for (var i = 0; i < d.length; i++) {
        totalphywt = totalphywt + parseFloat(d[i].physicalweight)
      }
      return totalphywt;
    },
    gettotalcharwt(d) {
      var totalcharwt = 0;
      for (var i = 0; i < d.length; i++) {
        totalcharwt = totalcharwt + parseFloat(d[i].chargeableweight)
      }
      return totalcharwt;
    },
    gettotalvolwt(d) {
      var totalvorwt = 0;
      for (var i = 0; i < d.length; i++) {
        totalvorwt = totalvorwt + parseFloat(d[i].volumetricweight)
      }
      return totalvorwt;
    },
    openRegularPrintModal(data) {
      this.showPrintModal = true
      this.modaldata = data
      this.printTripNo = this.modaldata.tripno;
      this.getTripDetailsForRegularPrint()
    },
    closeRegularPrintModal() {
      this.showPrintModal = false
      this.touchpointlist = []
      this.touchpointitem = {
        value: '',
        text: ''
      }
      this.touchpointname = ''
    },
    closeBagListModal() {
      this.showBagListModal = false
      this.bags = []
      this.bagCount = 0
      this.pageNoForBagList = 0
      this.bagCount = 0
      this.pageCountForBags = 0
      this.checkType='Ecom'
      this.shipments=[]
      this.isLoadingBagList=false
      // this.touchpointitem = {
      //   value: '',
      //   text: ''
      // }
      // this.touchpointname = ''
    },
    // selectedTouchPoint(touchpointitem) {
    //   this.touchpointitem = touchpointitem
    //   this.touchpointname = touchpointitem.text
    //   if (this.touchpointname != '') {
    //     var stoppointarr = []
    //     stoppointarr.push(this.touchpointitem.value)
    //     this.getshipmentdata(stoppointarr, this.currenthubid, this.connectionschedulemasterid);
    //   }
    // },
    getTripDetailsForRegularPrint() {
      this.tripdata = {};
      this.shipmentdata = {};
      this.isLoadingPrintSheet = true;
      this.tripdatafound = false;
      this.isValidPrint = false;
      this.printConfig = false;
      this.input = {
        "currentHubId" : Number(this.hubId),
        "VendorVehicleTripID": parseInt(this.modaldata.tripno)
      }
      axios({
          'method': 'POST',
          'url': apiUrl.api_url_hubops + 'GetNetworkTripDetails',
          'data': this.input,
          'headers': {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          this.isLoadingPrintSheet = false
          if (result.data.ResultCode == 100) {
            var response = result.data.ResponseData[0];
            var tripdata = response;
            this.tripdata = response;
            this.isValidPrint = result.data.isValidPrintRestrictions;
            this.printConfig =  index.configRolesCheck(result.data.config.pr_web_roles);
            // if(!this.isValidPrint || !this.printConfig) {
            //   this.showPrintModal = false;
            //   this.$alertify.error("No Printing Access");
            //   return;
            // }
            if (this.tripdata.TripType == 'MarketHired') {
              this.vendortype = 'Market'
            } else if (this.tripdata.TripType == 'VendorBased' || this.tripdata.TripType == 'NetworkBased' || this.tripdata.TripType == 'Network') {
              this.vendortype = 'Attached'
            } else {
              this.vendortype = ''
            }
            var stoppointarr = [];
            if (tripdata.Connectiondetails.length > 0) {
              var stoppoints = tripdata.Connectiondetails[0].Stoppoints
              for (var i = 0; i < stoppoints.length; i++) {
                stoppointarr.push(stoppoints[i].StopPointHubId);
                // this.touchpointlist.push({
                //   value: stoppoints[i].StopPointHubId,
                //   text: stoppoints[i].StopPointName,
                // });
              }
            }
            this.getshipmentdata(stoppointarr, this.currenthubid, this.connectionschedulemasterid);

            var arr = tripdata.ShipmentDetails
            if (arr.length > 0) {
              var input = {
                hubids: [arr[(arr.length) - 1].HubID]
              }
              return axios({
                  method: 'POST',
                  'url': apiUrl.api_url_hubops + "expose/hubservicecenter/hubarray/get",
                  'data': input,
                  headers: {
                    'authorization': 'authkey xB84JJ89Hd25',
                  }
                })
                .then(result => {
                  this.currenthub = result.data.ResponseData[0].HubName
                  this.tripdata = tripdata
                }, error => {
                  console.error(error)
                })

            }

          } else {
            this.$alertify.error("No record found")
          }
        }, error => {
          this.isDisplay = false
          console.error(error)
        })

    },
    getshipmentdata(stoppoints, currenthubid, connectionschedulemasterid) {
      this.shipmentdataLength = 0
      this.shipmentdata = []
      this.fullConnectionName = ''
      this.isLoadingPrintSheet = true;
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'getShipmentsFromTouchPoints?ConnectionScheduleMasterID=' + this.modaldata.connectionschedulemaster + '&CurrentHubId=' + this.modaldata.currenthubid + '&TouchPointHubId=' + stoppoints.join(','),
          // 'url': "http://huboperation-apistage.xbees.in/api/getShipmentsFromTouchPoints?ConnectionScheduleMasterID=" + this.modaldata.connectionschedulemasterid + "&CurrentHubId=" + this.modaldata.currenthubid + "&TouchPointHubId=" + stoppoints.join(','),
          headers: {
            'Authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          var shdata = [];
          this.isLoadingPrintSheet = false;
          if (result.data.ResultCode == 100) {
            this.isLoading = false;
            this.tripdatafound = true;
            this.shipmentdata = result.data.ResponseData;
            this.fullConnectionName = result.data.fullConnectionName;
            var baglength = Object.values(this.shipmentdata);
            Array.prototype.getLength = function() {
              function getMultiLength(array) {
                var sum = 0;
                for (var count = 0; count < array.length; count++) {
                  if (Array.isArray(array[count])) {
                    sum += getMultiLength(array[count]);
                  } else {
                    sum++;
                  }
                }
                return sum;
              }
              return getMultiLength(this.valueOf());
            };
            this.shipmentdataLength = baglength.getLength();
          } else {
            this.isLoading = false;
            this.shipmentdata = [];
            this.fullConnectionName = '';
            this.tripdatafound = false;
            this.$alertify.error("No record found")
          }
          this.isLoading = false
        }, error => {
          this.isDisplay = false
          this.isLoading = false
          this.isLoadingPrintSheet = false;
          console.error(error)
        })
    },


    getTripDetails(data, ind) {
      this.isLoading = true;
      this.VehicleTripDetailsData = []
      this.thcno = data.tripno;
      this.CSMID = data.connectionschedulemaster;
      data.contentVisible = !data.contentVisible;
      const index = this.opened.indexOf(data.thcno);
      var self = this
      if (index > -1) {
        this.opened.splice(index, 1)
      } else {
        this.opened = [];
        this.opened.push(data.thcno)
      }

      // $('#' + data.thcno).toggle('slow');
      this.input = {
        VendorVehicleTripID: parseInt(this.thcno)
      }
      axios({
          'method': 'POST',
          'url': apiUrl.api_url_hubops + 'GetTripConnectionSchedule',
          'data': this.input,
          'headers': {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          this.isLoading = false;
          if (result.data.ResultCode == 100) {
            this.VehicleTripDetailsData = result.data.ResponseData;
            this.getConnectionLogTable()
          }
        }, error => {
          this.isLoading = false;
          this.$alertify.error("Connection API Error")
          console.error(error)
        })
    },
    getConnectionLogTable() {
      this.totalRowsNew = 0
      this.isLoadingSearch = true
      this.showConnectionLogTable = true
      var FromDate = this.FromDate != '' ? this.getdate(this.FromDate) : ''
      var ToDate = this.ToDate != '' ? this.getdate(this.ToDate) : ''
      this.IsLocalConnection = true
      var isactive = true
      var tempClientarray = [];
      var tempfinalArray = [];
      var ConnectionScheduleMasterID = this.CSMID != '' ? this.CSMID : ''
      this.ConnectionLogFinalData = [];
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'tripConnectionScheduleReport?ConnectionScheduleMasterID=' + this.CSMID + '&ConnectionID=' + this.routenameitem.value +
            '&VehicleVendorID=' + this.vendorNameObjData.value + '&ScheduleStatus=' + this.status + '&CurrentHubId=' + this.CurrentHubNameObjData.value +
            '&THCNo=' + this.tripSheetNo + '&IsLocalConnection=' + this.IsLocalConnection + '&IsActive=' + isactive + '&FromDate=' + FromDate + '&ToDate=' + ToDate +
            '&RequestType=summary&offset=' + this.pageNoLog + '&limit=' + this.limitLog,

          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          this.isLoadingSearch = false;
          if (result.data.ResultCode == 100) {
            this.tripConnectionDetails = result.data.ResultData;
            this.totalRowsNew = result.data.TotalCount
            if (this.totalRowsNew < 10) {
              this.pageCountLog = 1
            } else {
              this.pageCountLog = Math.ceil(this.totalRowsNew / 10);
            }
            this.showTable = true
            for (var i = 0; i < this.hubdetailsarray.length; i++) {
              tempClientarray[this.hubdetailsarray[i].HubID] = this.hubdetailsarray[i].HubName;
            }
            for (var i = 0; i < this.tripConnectionDetails.length; i++) {
              tempfinalArray = [];
              tempfinalArray = this.tripConnectionDetails[i];
              if (this.tripConnectionDetails[i].currenthubid == "") {
                tempfinalArray["HubName"] = '';
              } else {
                tempfinalArray["HubName"] = tempClientarray[this.tripConnectionDetails[i].currenthubid];
              }
              this.ConnectionLogFinalData.push(tempfinalArray);
            }
          }
        }, error => {
          console.error(error)
        })
    },
    // getBagDetailsByShippingID() {
    //   this.viewtripmodel=true
    //   if (this.shippingID == '') {
    //     this.shippingIDErrorMSG = 'Enter Shipping ID';
    //     return false;
    //   }
    //   this.shippingIDErrorMSG = '';
    //   this.isLoadingSearch = true;
    //   this.input = ({
    //     "ShippingID": this.shippingID
    //   })
    //   axios({
    //       method: 'POST',
    //       url: apiUrl.api_url_hubops + 'getShipmentTransactionDetails',
    //       data: this.input,
    //       headers: {
    //         'authorization': 'authkey xB84JJ89Hd25'
    //       }
    //     })
    //     .then(result => {
    //       this.isLoadingSearch = false;
    //       if (result.data.ResultCode == 100) {
    //         this.shippingDetails = result.data.ResponseData;
    //         this.isEmpty = Object.keys(this.shippingDetails).length;
    //         let totalRows = result.data.length
    //         if (totalRows < 10) {
    //           this.pageCountrule = 1
    //         } else {
    //           this.pageCountrule = Math.ceil(totalRows / 10);
    //         }
    //       }
    //     }, error => {
    //       console.error(error)
    //     })
    // },


    getTotalCountForCargo() {
      this.bagCount=0;
      this.shipments=[];
      this.isLoadingBagList=true

      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'getShipmentCountByThcNo?thcNo=' + this.thcno,
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          this.isLoadingBagList=false;
          if (result.data.ResultCode == 100) {
              this.bagCount = result.data.TotalCount
              this.totalRowsBags=result.data.TotalCount
              if (this.totalRowsBags < this.limitBag) {
                this.pageCountForBags = 1
              } else {
                this.pageCountForBags = Math.ceil(this.totalRowsBags / this.limitBag);
              }
              this.ShowBagList();
          }else{
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          console.error(error)
        })
    },
    ShowBagList() {
      this.isLoadingBagList=true
      this.showBagListModal = true;
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'GetBagDetailsByTripsheetno?Tripsheetno=' + this.thcno + '&PageIndex='+ this.pageNoForBagList + '&PageSize='+ this.limitBag+'&ListType='+ this.checkType,
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          this.isLoadingBagList=false
          if (result.data.ResultCode == 100) {
            if(this.checkType == 'Ecom'){
              this.bagCount=0
              this.bags = result.data.ResponseData;
              this.bagCount = result.data.TotalCount
              this.totalRowsBags = result.data.TotalCount
              // this.$alertify.success(result.data.ReturnMessage)
              if (this.totalRowsBags < this.limitBag) {
                this.pageCountForBags = 1
              } else {
                this.pageCountForBags = Math.ceil(this.totalRowsBags / this.limitBag);
              }
            }else{
              var hubDetails =[]
  						var resultData=[]
  						for (var i = 0; i < this.DestHubNameData.length; i++) {
  							hubDetails[this.DestHubNameData[i].value] = this.DestHubNameData[i].text;
  						}
  						result.data.ResponseData.forEach(function(item) {
  							item["sourcehubname"] = '';
  							if (item.OriginHubID && hubDetails[item.OriginHubID]) {
  								item["sourcehubname"] = hubDetails[item.OriginHubID];
  							}
  							item["destinationhubname"] = '';
  							if (item.FinalDestinationID && hubDetails[item.FinalDestinationID]) {
  								item["destinationhubname"] = hubDetails[item.FinalDestinationID];
  							}
  							resultData.push(item);
  						});
  						this.shipments = resultData
              // this.bagCount = result.data.TotalCount
              // if (this.totalRowsBags < this.limitBag) {
              //   this.pageCountForBags = 1
              // } else {
              //   this.pageCountForBags = Math.ceil(this.totalRowsBags / this.limitBag);
              // }
            }
          }else{
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          console.error(error)
        })
    },
    formatWeight(value) {
      if (!value) return '0';
      const num = parseFloat(value);
      return Number.isInteger(num) ? `${num}` : `${parseFloat(num.toFixed(2))}`;
    },
    showGatePass(data) {
      this.viewtripmodel = true;
      this.CSMID = data.connectionschedulemaster;
      this.invoiceno = data.invoiceno;
      this.PrintBy = this.createdBy
      this.printTripNo = '';
      this.PrintDate = new Date();
      this.DestLoadCount = [];
      this.DestLoadCountUpdated = [];
      this.ebnDetailsB2B = [];
      this.ebnDetailsB2C = [];
      this.input = ({})
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'generateGatePass?ConnectionScheduleMasterID=' + this.CSMID,
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.GatePassDetails = index.getHubNameByHubId([result.data.ResultData[0].CurrentHub], result.data.ResultData, 'CurrentHub');
            this.DestLoadCount = result.data.Count;
            this.transitLocationHubIds = [...new Set(this.DestLoadCount.map(a => a.transit_location))];
            if(this.transitLocationHubIds.length > 0) {
              this.DestLoadCountUpdated = index.getHubNameByHubId(this.transitLocationHubIds, this.DestLoadCount, 'transit_location');
            }
            this.ebnDetailsB2B = result.data.ebn.B2Bebn;
            this.ebnDetailsB2C = result.data.ebn.B2Cebn;
            this.printTripNo = result.data.ResultData[0].thcno;
          }
        }, error => {
          console.error(error)
        })
    },
    ReOpenTrip() {
      this.input = ({
        "ConnectionScheduleMasterID": this.CSMID,
        "LastModifiedBy": this.createdBy,
        "IsAdmin": false
      })
      axios({
          method: 'PUT',
          url: apiUrl.api_url_hubops + 'reopenTrip',
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.$alertify.success(result.data.ReturnMessage);
          } else if (result.data.ResultCode == 101 || result.data.ResultCode == 500) {
            this.$alertify.error(result.data.ReturnMessage);
          }

        }, error => {
          console.error(error)
        })
    },
    hideviewtripmodel() {
      this.viewtripmodel = false;
      $(document.body).removeClass("modal-open");
      $(".modal-backdrop").remove();
    },
    ReOpenVehicle() {
      this.input = ({
        "ConnectionScheduleMasterID": this.CSMID,
        "CurrentHubId": this.hubId,
        "LastModifiedBy": this.createdBy
      })
      axios({
          method: 'PUT',
          url: apiUrl.api_url_hubops + 'reopenVehicle',
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.$alertify.success(result.data.ReturnMessage);
          } else {
            this.$alertify.error(result.data.ReturnMessage);
          }
        }, error => {
          console.error(error)
        })
    },
    printGatePass(type) {
      const d = new Printd();
      var buffer = '';

      this.input = {
        "currentHubId" : Number(this.hubId),
        "tripId" : Number(this.printTripNo.trim()),
        "createdBy" : this.useremail,
        "reportName" : type,
        "pageName" : "Local Vehicle Manifest"
      }
      axios({
        method: 'post',
        url: apiUrl.api_url_hubops + 'printGatePass',
        data: this.input,
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'authkey xB84JJ89Hd25',
        },
      })
      .then((result) => {
        if(result.data.ResultCode == 100) {
          console.log(result.data.ReturnMessage);
        } else {
          console.log(result.data.ReturnMessage);
        }
      })
      .catch((error) => console.log(error));

      var cssText = `
           body{
               -webkit-print-color-adjust:exact;
               font-family: Roboto,sans-serif;
           }
           table {
               border-collapse: collapse;
               margin-left:0px !important;
           }
           table, td, th {
             border-style: solid;
             border-width: 1px;
             padding:5px;
           }
           .text-right{
             text-align:right;
           }
           .text-left{
             text-align:left;
           }
           .text-center{
             text-align:center;
           }
           .h3-center-text{
             text-align:center;
           }
           @media print {
           .text-primary th{
             background-color:rgb(226, 216, 216) !important;
             color:black !important;
             font-size:20px !important;
           }
          }
          `

      if (type == "regularprint") {
        d.print(document.getElementById('regulartripsheetContent'), cssText);
      } else {
        d.print(document.getElementById('GatePass'), cssText);
      }
    },
    printInvoice(tripdata) {
      localStorage.setItem('pageName','Local Vehicle Manifest');
      if (tripdata.ConnectionScheduleMasterID == '' || tripdata.ConnectionScheduleMasterID == undefined || tripdata.ConnectionScheduleMasterID == null) {
        this.$alertify.error('Connection Schedule Master ID Not Found');
        return false
      }
      let routeData = this.$router.resolve("/TripGenerateConnectionPrint/" + tripdata.ConnectionScheduleMasterID + "/" + tripdata.ConnectionType + "/" + this.hubId)
      window.open(routeData.href, '_blank');

    },
    // getTripConnectionSchedule() {
    //   axios({
    //       method: 'POST',
    //       url: apiUrl.api_url_hubops + 'GetTripConnectionSchedule',
    //       data: this.input,
    //       headers: {
    //         'authorization': 'authkey xB84JJ89Hd25'
    //       }
    //     })
    //     .then(result => {
    //       this.isLoadingSearch = false;
    //       if (result.data.ResultCode == 100) {
    //         this.shippingDetails = result.data.ResponseData;
    //         this.isEmpty = Object.keys(this.shippingDetails).length;
    //         let totalRows = result.data.length
    //         if (totalRows < 10) {
    //           this.pageCountrule = 1
    //         } else {
    //           this.pageCountrule = Math.ceil(totalRows / 10);
    //         }
    //       }
    //     }, error => {
    //       console.error(error)
    //     })
    // },
    checkToDate() {
      var date1 = new Date(this.FromDate);
      date1.setDate(date1.getDate() + 30)
      this.validDateRange = date1
    },
    //validate all form fields on onsubmit()
    onSubmit: function() {
      var self = this
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.pageNo = 0
          this.getVehicleTripSummary()
        } else {
          console.log('errors exist', this.errors)
        }
      }).catch(() => {
        console.log('errors exist')
      });
    },
    getCSVFileByType(type){
      if(type == "Ecom")
      {
        this.getCSVFile();
      }else{
        this.getCSVFileForCargo();
      }
    },
    getCSVFile(){
      this.csvData=[]
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'GetBagDetailsByTripsheetnoForCSV?Tripsheetno=' + this.thcno,
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
              this.csvData=result.data.ResponseData;
              this.csvFields = {
                'parentbagno': 'BagNo',
                'sourcehubname': 'Source Hub',
                'destinationhubname': 'Destination Hub',
                'parentbagcount':'ParentBag Count',
                'plsbagcount': 'PLSBag Count',
                'shipmentcount': 'Shipment Count'
              }
              this.jsonToCSV('BagList_', this.csvData, this.csvFields);
          }else{
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          console.error(error)
        })
  },
  getCSVFileForCargo(){
    this.csvDataForCargo=[]
    this.isLoading = true;

    axios({
        method: 'GET',
        url: apiUrl.api_url_hubops + 'getShipmentDetailsByThcNo?thcNo=' + this.thcno,
        data: this.input,
        headers: {
          'authorization': 'authkey xB84JJ89Hd25'
        }
      })
      .then(result => {
        this.isLoading = false;
        if (result.data.ResultCode == 100) {
            var hubDetails =[]
            var resultData=[]
            for (var i = 0; i < this.DestHubNameData.length; i++) {
              hubDetails[this.DestHubNameData[i].value] = this.DestHubNameData[i].text;
            }
            result.data.ResponseData.forEach(function(item) {
              item["OriginHubName"] = '';
              if (item.OriginHubID && hubDetails[item.OriginHubID]) {
                item["OriginHubName"] = hubDetails[item.OriginHubID];
              }
              item["DestinationHubName"] = '';
              if (item.FinalDestinationID && hubDetails[item.FinalDestinationID]) {
                item["DestinationHubName"] = hubDetails[item.FinalDestinationID];
              }
              resultData.push(item);
            });
            this.csvDataForCargo = resultData



            this.csvFields = {
              'ShippingID': 'ShippingID',
              'ShipmentStatus': 'Shipment Status',
              'DestinationHubName': 'Destination Hub Name',
              'OriginHubName':'Origin Hub Name',
              'OriginHubID':'Origin Hub ID',
              'FinalDestinationID':'Final Destination ID'
            }
            this.jsonToCSV('ShipmentList_', this.csvDataForCargo, this.csvFields);
        }else{
          this.$alertify.error(result.data.ReturnMessage)
        }
      }, error => {
        console.error(error)
      })
},
  jsonToCSV(filename, data, csvfield, dateFilder = [], skipFilter = []) {
    var csvData = ''
    //Header
    if (this.title != null) {
      csvData += this.parseExtraData(this.title, '${data}\r\n')
    }
    //Fields
    for (let key in data[0]) {
      if (skipFilter.indexOf(key) == -1)
        csvData += csvfield[key] + ','
    }
    csvData = csvData.slice(0, csvData.length - 1)
    csvData += '\r\n'
    //Data
    data.map(function(item) {
      for (let key in item) {
        if (skipFilter.indexOf(key) == -1) {
          var escapedCSV = item[key] + '' // cast Numbers to string
          if (escapedCSV.match(/[,"\n]/)) {
            escapedCSV = '"' + escapedCSV.replace(/\"/g, "\"\"") + '"'
          }
          if (escapedCSV == 'null')
            csvData += ',';
          else {
            if (dateFilder.indexOf(key) != -1)
              csvData += moment(escapedCSV).format('DD-MM-YYYY HH:mm:ss') + ','
            else
              csvData += escapedCSV + ','
          }
        }
      }
      csvData = csvData.slice(0, csvData.length - 1)
      csvData += '\r\n'
    })
    //Footer
    if (this.footer != null) {
      csvData += this.parseExtraData(this.footer, '${data}\r\n')
    }
    filename += moment().format('DD-MM-YYYY') + '.csv';
    return this.export(csvData, filename, "application/csv");
    return csvData
  },
  export (data, filename, mime) {
    let blob = this.base64ToBlob(data, mime)
    download(blob, filename, mime)
    this.$alertify.success("Successful")
  },
  base64ToBlob(data, mime) {
    let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
    let bstr = atob(base64)
    let n = bstr.length
    let u8arr = new Uint8ClampedArray(n)
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
    }
    return new Blob([u8arr], {
      type: mime
    })
  },
    onChange(event,EcomOrCargo) {
      this.bagCount=0
      this.pageCountForBags=0
      this.shipments=[]
      this.bags=[]
      this.pageNoForBagList=0
      if(EcomOrCargo ==1)
      {
        this.getTotalCountForCargo();

      }else {
        this.ShowBagList();
      }
    },
    onSubmitSearch: function() {
      var self = this
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return false;
        }
        // this.$alertify.success("your message");
      }).catch(() => {
        console.log('errors exist')
        //this.$alertify.error("your message")
      });
    },
    printData(tripid, currenthubid, connectionschedulemasterid, connectionid) {
      localStorage.setItem('pageName','Local Vehicle Manifest');
      let path = this.$router.resolve("/TripSheetPrint/" + tripid.trim() + "/" + currenthubid + "/" + connectionschedulemasterid + "/" + connectionid)
      window.open(path.href, '_blank');
    },
    printDataFormCurrentTP(tripid, currenthubid, connectionschedulemasterid, connectionid) {
      let path = this.$router.resolve("/TripSheetPrintFromCurrentTP/" + tripid.trim() + "/" + currenthubid + "/" + connectionschedulemasterid + "/" + connectionid)
      window.open(path.href, '_blank');
    },
    printBulkDataFormCurrentTP(tripid, currenthubid, connectionschedulemasterid, connectionid) {
      let path = this.$router.resolve("/TripSheetPrintForBulkFromCurrentTP/" + tripid.trim() + "/" + currenthubid + "/" + connectionschedulemasterid + "/" + connectionid)
      window.open(path.href, '_blank');
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/VehicleTripSummary/VehicleTripSummary.js